/* ROUTINE FINDER
   Four questions, then a routine assembled from the answers.
   Product titles, prices, images and variant ids all come from Shopify via the section's JSON block,
   so nothing in this file needs touching when the catalogue changes. */
(function () {
  "use strict";

  var root = document.querySelector("[data-routine-finder]");
  if (!root) return;

  var dataEl = document.getElementById(root.dataset.products);
  if (!dataEl) return;
  var SHOP = JSON.parse(dataEl.textContent);

  var body = root.querySelector("[data-rf-body]");
  var footer = root.querySelector("[data-rf-footer]");
  var lang = (root.dataset.locale || "en").toLowerCase().indexOf("nl") === 0 ? "nl" : "en";

  var RF = window.RF_COPY || {};
  var T = RF.T, REASONS = RF.REASONS, REASON_ORDER = RF.REASON_ORDER, PMETA = RF.PMETA, EXTRAS = RF.EXTRAS || {};
  if (!T) return;

  /* The icon files live in Settings > Files; the section resolves their URLs for us. */

  /* A day answer and a moment icon are the same idea under two names. */
  /* Which of a product's own "when it helps most" badges answers the reason we gave.
     Left: the reason tag the engine picked. Right: the badge text on the product in
     Shopify, lowercased. No match means no moment chip, so we never invent one. */
  var MOMENT_MATCH = {
    sweat: ["after workouts"],
    out: ["before outdoors", "sunny days"],
    indoor: ["long screen days", "in dry office air", "on commute days", "after city days", "city living"],
    long: ["during travel"],
    breakouts: ["after a breakout"],
    sens: ["when skin feels tight", "stressed skin"],
    dry: ["when skin feels tight"],
    drytype: ["when skin feels tight"]
  };
  function norm(x) { return String(x == null ? "" : x).toLowerCase().trim(); }
  var ORDER = ["rr", "mm", "pp", "hh", "cc", "dw", "dd"];

  /* The products the routine left out. Off: the result screen is the answer to four
     questions, not a shop. Set to true to offer them again, folded under the price. */
  var SHOW_EXTRAS = false;

/* ---------- money ---------- */
  var MONEY = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || "€{{amount_with_comma_separator}}";
  function fmt(cents) {
    function n(dec, thou, sep) {
      var s = (cents / 100).toFixed(dec).split(".");
      var i = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? i + sep + s[1] : i;
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      if (name === "amount") return n(2, ",", ".");
      if (name === "amount_no_decimals") return n(0, ",", "");
      if (name === "amount_with_comma_separator") return n(2, ".", ",");
      if (name === "amount_no_decimals_with_comma_separator") return n(0, ".", "");
      if (name === "amount_with_apostrophe_separator") return n(2, "'", ".");
      return n(2, ".", ",");
    });
  }
  function discounted(cents) { return Math.round(cents * (100 - DPCT) / 100); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* ---------- automatic discount ----------
     Shopify applies it in the cart; the section settings only mirror it here so the
     result screen can show the right number. Keep the two in step. */
  var DPCT = parseInt(root.dataset.discountPercentage || "0", 10);
  var DMIN = parseInt(root.dataset.discountMinItems || "3", 10);
  function discountOn(count) { return DPCT > 0 && count >= DMIN; }

  /* ---------- state ---------- */
  var screen = "intro", NQ = 4;
  var A = { day: [], type: null, concern: null, react: null, tier: "complete" };
  /* What the reader kept or added on top of what we suggested. Cleared whenever the
     routine underneath it is rebuilt. */
  var picks = {};
  /* True while the reader is changing one answer from the result, so we take them
     back to the routine instead of walking the remaining questions again. */
  var editing = false;
  function t() { return T[lang]; }
  function labelOf(list, key) { for (var i = 0; i < list.length; i++) if (list[i][0] === key) return list[i][1]; return key; }

  /* ---------- the cicle in a link ----------
     Everything the reader chose fits in a short code, so a saved link needs no account
     and no database. It also keeps the answers out of plain sight when a link is shared. */
  var CODE = {
    day:     { out: "o", indoor: "i", sweat: "s", long: "l" },
    type:    { normal: "n", dry: "d", oily: "y", combi: "c" },
    concern: { breakouts: "b", dry: "r", dull: "u", lines: "f", none: "x" },
    react:   { low: "l", some: "s", high: "h" },
    tier:    { essential: "e", complete: "c", full: "f" }
  };
  function decodeMap(m, ch) {
    for (var k in m) if (m[k] === ch) return k;
    return null;
  }
  function encodeState() {
    var parts = [
      A.day.map(function (d) { return CODE.day[d]; }).join(""),
      A.type ? CODE.type[A.type] : "",
      A.concern ? CODE.concern[A.concern] : "",
      A.react ? CODE.react[A.react] : "",
      CODE.tier[A.tier]
    ];
    var over = [];
    for (var k in picks) over.push(k + (picks[k] ? "1" : "0"));
    if (over.length) parts.push(over.join("."));
    return parts.join("_");
  }
  function decodeState(code) {
    var p = String(code).split("_");
    if (p.length < 5) return false;
    var day = [];
    p[0].split("").forEach(function (ch) {
      var d = decodeMap(CODE.day, ch);
      if (d && day.length < 2) day.push(d);
    });
    var type = decodeMap(CODE.type, p[1]);
    var concern = decodeMap(CODE.concern, p[2]);
    var react = decodeMap(CODE.react, p[3]);
    var tier = decodeMap(CODE.tier, p[4]);
    if (!day.length || !type || !concern || !react || !tier) return false;
    A = { day: day, type: type, concern: concern, react: react, tier: tier };
    picks = {};
    if (p[5]) {
      p[5].split(".").forEach(function (bit) {
        var key = bit.slice(0, -1), on = bit.slice(-1) === "1";
        if (SHOP[key]) picks[key] = on;
      });
    }
    return true;
  }
  function cicleLink() {
    var u = new URL(window.location.href);
    u.searchParams.set("cicle", encodeState());
    return u.toString();
  }

  /* ---------- engine ---------- */
  function build() {
    var L = t(), out = { am: [], pm: [], left: [], uniq: [], twice: {} };
    var hasD = function (k) { return A.day.indexOf(k) > -1; };
    var TY = A.type, C = A.concern, R = A.react, S = A.tier;
    var cKey = C || (TY === "dry" ? "dry" : "none");
    if (C === "none" && TY === "dry") cKey = "dry";

    var useGel = (C === "breakouts" || TY === "oily" || (TY === "combi" && C !== "dry") || hasD("sweat")) && R !== "high" && C !== "dry";
    var amCl = null, pmCl = null;
    if (TY) {
      if (R === "high") amCl = pmCl = "mm";
      else if (useGel) { if (S === "full" && TY === "combi") { amCl = "mm"; pmCl = "rr"; } else amCl = pmCl = "rr"; }
      else amCl = pmCl = "mm";
    }

    var wantPP = (C === "dull" || C === "lines" || hasD("out") || hasD("indoor"));
    var wantHH = (C === "dry" || C === "breakouts" || TY === "dry" || hasD("indoor") || hasD("long"));
    var ppBlocked = (R === "high" && !(C === "dull" || C === "lines"));
    if (ppBlocked) wantPP = false;
    var ppFirst = (C === "dull" || C === "lines");
    var b1 = null, b2 = null;
    if (S === "complete") {
      if (ppFirst && wantPP) b1 = "pp"; else if (wantHH) b1 = "hh"; else if (wantPP) b1 = "pp";
    } else if (S === "full") {
      if (wantPP) b1 = "pp";
      if (wantHH) { if (b1) b2 = "hh"; else b1 = "hh"; }
    }

    var pmB = null, pmB2 = null, ov = null;
    if (S === "essential") { if (wantHH) pmB = "hh"; }
    else {
      var wantCC = R !== "high" && cKey !== "dry";
      if (wantCC) pmB = "cc";
      else if (wantHH || cKey === "dry") pmB = "hh";
    }
    /* Retinol is not an every-night product, and the product pages say so: two or
       three nights to start, hydration on the nights in between. So a routine with
       Complexion Care in it gets both middle steps, the way The Reset Cicle and The
       Recover Cicle do, instead of leaving the other nights with no middle step. */
    if (pmB === "cc") pmB2 = "hh";
    if (S === "full") ov = "dw";
    else if (S === "complete" && (hasD("long") || cKey === "dry" || C === "lines")) ov = "dw";
    /* Dewy Dream is the step that makes the retinol nights tolerable, so it is not
       optional once Complexion Care is in. */
    if (pmB === "cc") ov = "dw";

    out.am = [{ slot: "cleanse", p: amCl }, { slot: "boost", p: b1 }];
    if (S === "full") out.am.push({ slot: "boost", p: b2 });
    out.am.push({ slot: "protect", p: A.day.length ? "dd" : null });
    out.pm = [{ slot: "cleanse", p: pmCl }];
    if (pmB2) {
      out.pm.push({ slot: "boostOn", p: pmB });
      out.pm.push({ slot: "boostOff", p: pmB2 });
    } else {
      out.pm.push({ slot: "boost", p: pmB });
    }
    if (S !== "essential") out.pm.push({ slot: "protect", p: ov });
    out.alternates = !!pmB2;

    function reasonFor(k) {
      var bank = REASONS[lang][k], order = REASON_ORDER[k] || [];
      for (var i = 0; i < order.length; i++) {
        var tag = order[i], hit = false;
        if (tag === "sweat" || tag === "out" || tag === "indoor" || tag === "long") hit = hasD(tag);
        else if (tag === "sens") hit = (R === "high");
        else if (tag === "drytype") hit = (TY === "dry");
        else if (tag === "oily" || tag === "combi") hit = (TY === tag);
        else hit = (C === tag);
        if (hit && bank[tag]) return [bank[tag], tag];
      }
      return [bank.def, null];
    }
    out.am.concat(out.pm).forEach(function (s) {
      if (!s.p) return;
      var r = reasonFor(s.p);
      s.why = r[0];
      s.tag = r[1];
      if (PMETA[s.p].note && (R === "high" || R === "some" || s.p === "cc")) s.cav = PMETA[s.p].note[lang];
    });

    var seen = {};
    out.am.concat(out.pm).forEach(function (s) { if (s.p && !seen[s.p]) { seen[s.p] = 1; out.uniq.push(s.p); } });
    var amSet = {}; out.am.forEach(function (s) { if (s.p) amSet[s.p] = 1; });
    out.pm.forEach(function (s) { if (s.p && amSet[s.p]) out.twice[s.p] = 1; });
    /* Available, and never the same variant twice: two slots can point at one product. */
    var seenVariant = {};
    out.uniq = out.uniq.filter(function (k) {
      if (!SHOP[k] || !SHOP[k].available) return false;
      if (seenVariant[SHOP[k].variantId]) return false;
      seenVariant[SHOP[k].variantId] = 1;
      return true;
    });
    out.total = out.uniq.reduce(function (x, k) { return x + SHOP[k].price; }, 0);

    return out;
  }


  /* ------------------------------------------------------------------
     Rendering.
     Everything below builds the theme's own markup: .checkbox-control for
     every answer, .horizontal-product-card for every product, accordion-
     disclosure for the two panels, .button / .link / .button-group for the
     actions. The only classes this file invents are layout ones, prefixed
     routine-finder__.
     ------------------------------------------------------------------ */

  var uid = 0;

  /* Answers already given, as buttons that jump back to that question.
     Same markup as a small outline button anywhere else in the theme. */
  function chips() {
    var L = t(), c = [];
    A.day.forEach(function (k) { c.push([1, labelOf(L.o1, k)]); });
    if (A.type) c.push([2, labelOf(L.o2, A.type)]);
    if (A.concern) c.push([3, labelOf(L.o3, A.concern)]);
    if (A.react) c.push([4, labelOf(L.o4, A.react)]);
    /* The answer to the question on screen is already right there, as a checked box. */
    c = c.filter(function (x) { return x[0] !== screen; });
    if (!c.length) return "";
    return '<div class="active-facets routine-finder__chips">' + c.map(function (x) {
      return '<button type="button" class="button button--sm animated-border-button" data-rf-goto="' +
        x[0] + '"><span class="sr-only">' + esc(L.change) + " </span>" + esc(x[1]) + "</button>";
    }).join("") + "</div>";
  }

  /* One answer = the checkbox component's markup, exactly as the collection filters use it. */
  function choice(name, value, label, hint, checked, multi) {
    var id = "rf-" + name + "-" + value + "-" + (++uid);
    return '<div class="checkbox-control routine-finder__choice">' +
      '<input class="checkbox" type="' + (multi ? "checkbox" : "radio") + '" id="' + id + '" name="rf-' + name + '" value="' + esc(value) + '"' + (checked ? " checked" : "") + ">" +
      '<label for="' + id + '"><span class="routine-finder__choice-label">' + esc(label) + "</span>" +
      (hint ? '<span class="text-subdued text-sm">' + esc(hint) + "</span>" : "") +
      "</label></div>";
  }

  function choiceList(name, list, sel, multi) {
    return '<div class="v-stack divide-y routine-finder__choices" data-rf-group="' + name + '">' +
      list.map(function (o) {
        var on = multi ? sel.indexOf(o[0]) > -1 : sel === o[0];
        return choice(name, o[0], o[1], o[2], on, multi);
      }).join("") + "</div>";
  }

  function accordion(title, content, open) {
    return '<accordion-disclosure class="accordion">' +
      '<details class="accordion__disclosure group"' + (open ? ' open aria-expanded="true"' : ' aria-expanded="false"') + ">" +
      "<summary><span class=\"accordion__toggle h6\"><span>" + esc(title) + "</span>" +
      '<span class="animated-plus group-expanded:rotate" aria-hidden="true"></span></span></summary>' +
      '<div class="accordion__content">' + content + "</div>" +
      "</details></accordion-disclosure>";
  }

  function question(n, obj, opts, sel, multi, ready, nextLabel) {
    var L = t();
    return chips() +
      '<div class="v-stack gap-2">' +
        '<p class="text-subdued text-xs routine-finder__step">' + esc(L.progQ(n, NQ)) + "</p>" +
        '<p class="h3">' + esc(obj.h) + "</p>" +
        '<p class="text-subdued">' + esc(obj.s) + "</p>" +
      "</div>" +
      choiceList(n, opts, sel, multi) +
      '<div class="button-group">' +
        '<button type="button" class="button animated-border-button" data-rf-next' + (ready ? "" : " disabled") + ">" + esc(nextLabel) + "</button>" +
        (n > 1 ? '<button type="button" class="link" data-rf-back>' + esc(L.back) + "</button>" : "") +
      "</div>" +
      (multi ? '<p class="text-subdued text-sm" data-rf-max' + (sel.length > 1 ? "" : " hidden") + ">" + esc(obj.max) + "</p>" : "");
  }

  function render() {
    var L = t(), h = "";
    footer.hidden = true;
    footer.innerHTML = "";
    if (screen === "intro") { wire(); return; }
    var onward = editing ? L.see : L.next;
    if (screen === 1) h = question(1, L.q1, L.o1, A.day, true, A.day.length > 0, onward);
    else if (screen === 2) h = question(2, L.q2, L.o2, A.type, false, !!A.type, onward);
    else if (screen === 3) h = question(3, L.q3, L.o3, A.concern, false, !!A.concern, onward);
    else if (screen === 4) h = question(4, L.q4, L.o4, A.react, false, !!A.react, L.see);
    else h = resultHTML();

    /* The routine reads as two columns, so the modal is given more room for it. */
    root.classList.toggle("routine-finder--result", screen === "result");
    body.innerHTML = '<div class="v-stack gap-8">' + h + "</div>";
    scrollTop();
    wire();
  }

  function scrollTop() {
    var content = root.shadowRoot && root.shadowRoot.querySelector('[part="content"]');
    if (content) content.scrollTop = 0;
    body.scrollTop = 0;
  }

  /* ---------- result ---------- */
  function buildLine(L, E) {
    var bl = L.buildPre;
    if (A.type) {
      bl += "<b>" + esc(L.skinWord(L.typeNames[A.type])) + "</b>";
      if (A.concern && A.concern !== "none") bl += L.withWord + "<b>" + esc(L.concernShort[A.concern]) + "</b>";
    } else if (A.concern && A.concern !== "none") bl += "<b>" + esc(L.concernShort[A.concern]) + "</b>";
    if (A.react === "high") bl += L.reactPhrase;
    if (A.day.length) bl += ", " + A.day.map(function (k) { return L.dayPhrase[k]; }).join(E ? " and " : " en ");
    return bl + ".";
  }

  /* ---------- icons ----------
     Cicle already draws these: they are the same files the product pages use for
     "When it helps most" and "Benefits". We show the moment that matches the answer
     the reader gave, then what the product does. */
  /* A badge, drawn with the product page's own pictogram. The label is translated
     when we have a translation for it and left as written when we do not. */
  function iconChip(icon, label) {
    if (!label) return "";
    var img = icon
      ? '<img src="' + esc(icon) + '" alt="" width="20" height="20" loading="lazy" onerror="this.remove()">'
      : "";
    return '<span class="routine-finder__chip text-with-icon text-xs">' + img +
      "<span>" + esc(label) + "</span></span>";
  }
  function badgeChip(map, badge) {
    if (!badge) return "";
    return iconChip(badge.icon, map[norm(badge.label)] || badge.label);
  }
  /* The one "when it helps most" badge that matches the reason we gave, if the
     product carries one. */
  function momentBadge(key, tag) {
    var want = tag && MOMENT_MATCH[tag];
    if (!want) return null;
    var list = (SHOP[key] && SHOP[key].moments) || [];
    for (var i = 0; i < list.length; i++) {
      if (want.indexOf(norm(list[i].label)) > -1) return list[i];
    }
    return null;
  }
  /* One moment plus the product's three benefits, all straight off the product. */
  function iconRow(L, key, tag) {
    var chips = badgeChip(L.moment, momentBadge(key, tag));
    ((SHOP[key] && SHOP[key].benefits) || []).forEach(function (b) {
      chips += badgeChip(L.benefit, b);
    });
    return chips ? '<div class="routine-finder__icons">' + chips + "</div>" : "";
  }
  /* For an extra, the moment its pitch is written about. */
  function namedMoment(key, wanted) {
    var list = (SHOP[key] && SHOP[key].moments) || [], w = norm(wanted);
    for (var i = 0; i < list.length; i++) if (norm(list[i].label) === w) return list[i];
    return null;
  }

  /* ---------- what is actually in the cart ----------
     The engine suggests; the reader decides. A product is in unless it was switched
     off, and an extra is out unless it was switched on. */
  function inCicle(b, k) {
    var suggested = b.uniq.indexOf(k) > -1;
    return suggested ? picks[k] !== false : picks[k] === true;
  }
  function chosen(b) {
    var seen = {};
    return ORDER.filter(function (k) {
      if (!SHOP[k] || !SHOP[k].available || !inCicle(b, k)) return false;
      if (seen[SHOP[k].variantId]) return false;
      seen[SHOP[k].variantId] = 1;
      return true;
    });
  }
  /* Two slots can point at the same bottle. The cart counts it once, so everything on
     screen follows the bottle: the first key that carries this variant owns the state. */
  function ownerKey(b, k) {
    var vid = SHOP[k] && SHOP[k].variantId;
    if (!vid || !b) return k;
    for (var i = 0; i < b.uniq.length; i++) {
      if (SHOP[b.uniq[i]].variantId === vid) return b.uniq[i];
    }
    return k;
  }

  function pickBox(b, key, label) {
    var on = inCicle(b, key);
    var id = "rf-pick-" + key + "-" + (++uid);
    return '<div class="checkbox-control routine-finder__pick">' +
      '<input class="checkbox" type="checkbox" id="' + id + '" data-rf-pick="' + key + '"' + (on ? " checked" : "") + ">" +
      '<label for="' + id + '"><span class="text-subdued text-xs routine-finder__slot">' + esc(label) + "</span></label></div>";
  }

  /* The picture, not a link. Every link on this screen is a way out of the quiz at the
     moment someone is deciding, so the cards are inert and the only things to click are
     the checkbox and the button in the footer. */
  function figureHTML(sp) {
    if (!sp.image) return "";
    return '<div class="horizontal-product-card__figure">' +
      '<img class="horizontal-product-card__image" src="' + esc(sp.image) + '"' + (sp.imageSrcset ? ' srcset="' + esc(sp.imageSrcset) + '" sizes="70px"' : "") + ' alt="' + esc(sp.imageAlt) + '" width="200" height="200" loading="lazy">' +
      "</div>";
  }

  /* The sentence under a product. The nights-in-between step carries the alternation
     instead of a reason, because that is the thing worth saying there. */
  function reasonLine(L, row, repeat, twiceLine) {
    if (row.slot === "boostOff") return repeat ? L.offNightTwice : L.offNight;
    return repeat ? twiceLine : (row.why || "");
  }

  function productCard(row, index, slotLabel, repeat, twiceLine) {
    var sp = SHOP[row.p], m = PMETA[row.p], pk = ownerKey(b_current, row.p);
    var fig = figureHTML(sp);
    var L = t();
    return '<div class="horizontal-product-card routine-finder__product' + (inCicle(b_current, pk) ? "" : " is-off") + '" data-rf-card="' + pk + '">' + fig +
      '<div class="horizontal-product-card__info">' +
        '<div class="v-stack gap-1 justify-items-start">' +
          pickBox(b_current, pk, (index + 1) + " · " + slotLabel) +
          '<span class="product-title h6">' + esc(sp.title) + "</span>" +
          '<p class="text-sm">' + esc(reasonLine(L, row, repeat, twiceLine)) + "</p>" +
          (repeat ? "" : iconRow(L, row.p, row.tag)) +
          '<p class="text-subdued text-xs">' + esc(m.inci) + "</p>" +
          (!repeat && row.cav ? '<p class="text-subdued text-xs">' + esc(row.cav) + "</p>" : "") +
        "</div>" +
      "</div></div>";
  }

  /* ---------- a product that did not make the routine ---------- */
  function extraCard(L, b, key) {
    var sp = SHOP[key], m = PMETA[key], e = EXTRAS[key];
    if (!sp || !sp.available || !e) return "";
    var fig = figureHTML(sp);
    return '<div class="horizontal-product-card routine-finder__product" data-rf-card="' + key + '" data-rf-extra>' + fig +
      '<div class="horizontal-product-card__info">' +
        '<div class="v-stack gap-1 justify-items-start">' +
          pickBox(b, key, L.addLabel) +
          '<span class="product-title h6">' + esc(sp.title) + "</span>" +
          '<p class="text-sm">' + esc(e[lang]) + "</p>" +
          (function () {
            var c = badgeChip(L.moment, namedMoment(key, e.moment));
            return c ? '<div class="routine-finder__icons">' + c + "</div>" : "";
          })() +
          '<p class="text-subdued text-xs">' + esc(m.inci) + "</p>" +
        "</div>" +
      "</div></div>";
  }

  /* ---------- clean by design ----------
     The same badge-list the product pages use, with the same labels. Every product
     carries its own list in PMETA, and we show what the whole routine has in common,
     so a routine with a fragranced product does not claim to be fragrance free. */
  /* The order we print them in. Anything the products carry that is not on this
     list is printed after it, in the order the first product lists it. */
  var CLAIM_ORDER = [
    "fragrance free", "paraben free", "silicone free", "sulfate free",
    "microplastic free", "essential oil free", "vegan"
  ];
  var NATURAL = /^(\d+)%\s*natural$/;
  /* The store writes these badges by hand, so the same claim turns up spelled a few
     ways. Fold those together before comparing, and correct "silicon" to "silicone"
     while we are here: silicon is the element, silicone is what is not in the bottle. */
  function claimKey(x) {
    return norm(x).replace(/microplastics/g, "microplastic").replace(/\bsilicon\b/g, "silicone");
  }
  function claimLabel(L, c) {
    var m = NATURAL.exec(c);
    if (m) return m[1] + L.claims.natural;
    return L.claims[c] || c;
  }

  function claimsHTML(L, keys) {
    if (!keys.length) return "";
    var lists = keys.map(function (k) { return ((SHOP[k] && SHOP[k].claims) || []).map(claimKey); });
    var shared = lists[0].filter(function (c) {
      return lists.every(function (l) { return l.indexOf(c) > -1; });
    });
    shared.sort(function (a, b) {
      var ia = CLAIM_ORDER.indexOf(a), ib = CLAIM_ORDER.indexOf(b);
      if (ia < 0) ia = CLAIM_ORDER.length + (NATURAL.test(a) ? 0 : 1);
      if (ib < 0) ib = CLAIM_ORDER.length + (NATURAL.test(b) ? 0 : 1);
      return ia - ib;
    });
    var labels = shared.map(function (c) { return claimLabel(L, c); });
    if (!labels.length) return "";

    return '<p class="h6">' + esc(L.freeFromH) + "</p>" +
      '<badge-list class="badge-list routine-finder__badges">' +
      labels.map(function (t) { return '<span class="badge badge--custom">' + esc(t) + "</span>"; }).join("") +
      "</badge-list>";
  }

  /* The routine the reader is currently looking at, so a card can ask about it. */
  var b_current = null;

  function priceHTML(L, keys) {
    var total = keys.reduce(function (x, k) { return x + SHOP[k].price; }, 0);
    var h = "";
    keys.forEach(function (k) {
      h += '<div class="h-stack justify-between gap-4"><span class="text-sm">' + esc(SHOP[k].title) + '</span><span class="text-sm">' + esc(SHOP[k].priceFormatted) + "</span></div>";
    });
    if (!keys.length) return '<p class="text-subdued text-sm">' + esc(L.emptyCart) + "</p>";
    if (discountOn(keys.length)) {
      h += '<div class="h-stack justify-between gap-4 routine-finder__total"><span class="text-sm">' + esc(L.subtotal) + '</span><span class="text-sm">' + fmt(total) + "</span></div>" +
        '<div class="h-stack justify-between gap-4"><span class="text-sm">' + esc(L.discountRow(DPCT)) + '</span><span class="text-sm">&minus;' + fmt(total - discounted(total)) + "</span></div>" +
        '<div class="h-stack justify-between gap-4 routine-finder__total"><span class="h6">' + esc(L.total) + '</span><span class="h6">' + fmt(discounted(total)) + "</span></div>";
    } else {
      h += '<div class="h-stack justify-between gap-4 routine-finder__total"><span class="h6">' + esc(L.total) + '</span><span class="h6">' + fmt(total) + "</span></div>";
    }
    return h;
  }

  function footerHTML(L, keys) {
    var total = keys.reduce(function (x, k) { return x + SHOP[k].price; }, 0);
    var payable = discountOn(keys.length) ? discounted(total) : total;
    return '<div class="v-stack gap-3">' +
      (discountOn(keys.length)
        ? '<p class="text-subdued text-sm text-center">' + esc(DMIN > 1 ? L.discountNote(DPCT, DMIN) : L.discountAll(DPCT)) + "</p>"
        : "") +
      '<button type="button" class="button w-full animated-border-button" data-rf-add' + (keys.length ? "" : " disabled") + ">" +
        esc(root.dataset.cta || L.cta) + (keys.length ? " &middot; " + fmt(payable) : "") + "</button>" +
      '<button type="button" class="link text-subdued routine-finder__restart" data-rf-restart>' + esc(L.restart) + "</button>" +
      "</div>";
  }

  /* Switching a product on or off changes the price, the badges and the button, but
     not the routine underneath. So we rewrite those three and leave the page still. */
  function refresh() {
    if (!b_current) return;
    var L = t(), keys = chosen(b_current);
    var price = body.querySelector("[data-rf-price]");
    if (price) price.innerHTML = priceHTML(L, keys);
    var claims = body.querySelector("[data-rf-claims]");
    if (claims) claims.innerHTML = claimsHTML(L, keys);
    Array.prototype.forEach.call(body.querySelectorAll("[data-rf-card]:not([data-rf-extra])"), function (card) {
      card.classList.toggle("is-off", !inCicle(b_current, card.getAttribute("data-rf-card")));
    });
    footer.innerHTML = footerHTML(L, keys);
    /* Switching a product off is part of the cicle, so the saved link follows it. */
    try { window.history.replaceState(null, "", cicleLink()); } catch (e) {}
    wire();
  }

  /* ---------- keeping it ----------
     A link that restores the whole thing, and, when the shop has a flow ready for it,
     the same link by email. Both are optional: the reader can simply leave. */
  function keepHTML(L) {
    var mail = root.dataset.email === "true";
    return '<div class="v-stack gap-3" data-rf-keep>' +
      '<div class="v-stack gap-1"><p class="h6">' + esc(L.keepH) + '</p><p class="text-subdued text-sm">' + esc(L.keepS) + "</p></div>" +
      '<div class="button-group">' +
        '<button type="button" class="button button--sm animated-border-button" data-rf-copy>' + esc(L.copyLabel) + "</button>" +
        (mail ? '<button type="button" class="link" data-rf-email>' + esc(L.emailLabel) + "</button>" : "") +
      "</div>" +
      (mail
        ? '<div class="v-stack gap-3 routine-finder__mail" data-rf-mailform hidden>' +
            '<input class="input" type="email" inputmode="email" autocomplete="email" data-rf-mailfield aria-label="' + esc(L.emailField) + '" placeholder="' + esc(L.emailField) + '">' +
            '<div class="checkbox-control">' +
              '<input class="checkbox" type="checkbox" id="rf-optin" data-rf-optin>' +
              '<label for="rf-optin"><span class="text-sm">' + esc(L.emailOptIn) + "</span></label>" +
            "</div>" +
            '<p class="text-subdued text-xs">' + esc(L.emailNote) + "</p>" +
            '<div class="button-group"><button type="button" class="button button--sm animated-border-button" data-rf-mailsend>' + esc(L.emailSend) + "</button></div>" +
          "</div>"
        : "") +
      "</div>";
  }

  /* Two levels can land on the same routine, because we only add what the answers ask
     for. Showing the count and the price means the reader sees that before clicking. */
  function tiersWithPrice(L) {
    var held = A.tier;
    var out = L.tiers.map(function (x) {
      A.tier = x[0];
      var b = build(), n = b.uniq.length;
      A.tier = held;
      var payable = discountOn(n) ? discounted(b.total) : b.total;
      return [x[0], x[1], x[2] + " · " + n + " × · " + fmt(payable)];
    });
    A.tier = held;
    return out;
  }

  function resultHTML() {
    var L = t(), b = build(), E = lang === "en", seenCol = {};
    b_current = b;

    var h = chips();
    h += '<div class="v-stack gap-2">' +
      '<p class="h3">' + esc(L.resultH) + "</p>" +
      '<p class="routine-finder__buildline">' + buildLine(L, E) + "</p>" +
      '<p class="text-subdued text-sm">' + esc(L.closing) + "</p>" +
      "</div>";

    function column(arr, head, sub, empty) {
      var rows = arr.filter(function (s) { return s.p && SHOP[s.p] && SHOP[s.p].available; });
      var s = '<div class="v-stack gap-5"><div class="v-stack gap-1"><p class="h6">' + esc(head) + '</p><p class="text-subdued text-sm">' + esc(sub) + "</p></div>";
      if (!rows.length) return s + '<p class="text-subdued text-sm">' + esc(empty) + "</p></div>";
      s += '<div class="v-stack gap-5 divide-y routine-finder__list">';
      rows.forEach(function (r, i) {
        var vid = SHOP[r.p].variantId;
        s += productCard(r, i, L.slot[r.slot], !!seenCol[vid], L.twiceADay);
        seenCol[vid] = 1;
      });
      return s + "</div></div>";
    }
    h += '<p class="text-subdued text-sm">' + esc(L.pickHint) + "</p>";
    h += '<div class="routine-finder__cols">' +
      column(b.am, L.morning, L.amSub, "") +
      column(b.pm, L.evening, b.alternates ? L.pmSubAlt : L.pmSub, L.emptyEve) +
      "</div>";

    /* The level comes after the routine, not before it: you can only judge how much you
       want to use once you have seen what it is. */
    h += '<div class="v-stack gap-4">' +
      '<div class="v-stack gap-1"><p class="h6">' + esc(L.tierH) + "</p>" +
        (L.tierS ? '<p class="text-subdued text-sm">' + esc(L.tierS) + "</p>" : "") + "</div>" +
      choiceList("tier", tiersWithPrice(L), A.tier, false) +
      "</div>";

    var keys = chosen(b);
    h += '<div class="v-stack gap-3" data-rf-claims>' + claimsHTML(L, keys) + "</div>";

    /* What it costs and what we left out are both offers to read on, not things in the
       way of the decision. Folded, in the theme's own accordion, under the routine. */
    var panels = accordion(L.priceH, '<div class="v-stack gap-2 routine-finder__price" data-rf-price>' + priceHTML(L, keys) + "</div>", false);
    if (SHOW_EXTRAS) {
      var extras = ORDER.filter(function (k) { return b.uniq.indexOf(k) === -1 && SHOP[k] && SHOP[k].available && EXTRAS[k]; });
      if (extras.length) {
        panels += accordion(L.extrasH + " (" + extras.length + ")",
          '<div class="v-stack gap-5 divide-y routine-finder__list">' +
          extras.map(function (k) { return extraCard(L, b, k); }).join("") +
          "</div>", false);
      }
    }
    h += '<div class="accordion-list">' + panels + "</div>";
    h += keepHTML(L);
    h += '<p class="text-subdued text-xs">' + esc(L.disclaim) + "</p>";

    /* A saved link should survive a refresh and a bookmark. */
    try { window.history.replaceState(null, "", cicleLink()); } catch (e) {}

    footer.hidden = false;
    footer.innerHTML = footerHTML(L, keys);
    return h;
  }


  /* ---------- cart ---------- */
  function addToCart(btn) {
    var b = b_current || build();
    var items = chosen(b).map(function (k) { return { id: SHOP[k].variantId, quantity: 1 }; });
    if (!items.length) return;
    btn.disabled = true;
    var original = btn.innerHTML;
    fetch(root.dataset.cartAddUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      return r.json();
    }).then(function () {
      /* The theme's own refresh event: the drawer, the header count and the free
         shipping bar all listen for it. */
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      close();
      setTimeout(function () {
        var drawer = document.getElementById("cart-drawer");
        if (drawer && typeof drawer.show === "function") drawer.show();
        else {
          var opener = document.querySelector('[aria-controls="cart-drawer"]');
          if (opener) opener.click();
        }
      }, 300);
    }).catch(function () {
      btn.disabled = false;
      btn.innerHTML = original;
      var err = document.createElement("p");
      err.className = "text-subdued text-sm";
      err.textContent = t().cartError;
      footer.appendChild(err);
    });
  }

  /* ---------- sending it ----------
     Klaviyo is already on every page, so we hand it the profile and an event and let
     the shop's own flow write and send the mail. Nothing is stored in the theme. */
  function sendCicle(btn) {
    var L = t(), form = body.querySelector("[data-rf-mailform]");
    if (!form) return;
    var field = form.querySelector("[data-rf-mailfield]");
    var email = (field && field.value || "").trim();
    var optIn = !!form.querySelector("[data-rf-optin]:checked");
    var err = form.querySelector("[data-rf-mailerror]");
    if (err) err.remove();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      var p = document.createElement("p");
      p.className = "text-subdued text-sm";
      p.setAttribute("data-rf-mailerror", "");
      p.textContent = L.emailBad;
      form.appendChild(p);
      if (field) field.focus();
      return;
    }
    var b = b_current || build(), keys = chosen(b);
    var total = keys.reduce(function (x, k) { return x + SHOP[k].price; }, 0);
    var payload = {
      Products: keys.map(function (k) { return SHOP[k].title; }),
      ProductUrls: keys.map(function (k) { return SHOP[k].url; }),
      Total: total / 100,
      Link: cicleLink(),
      Language: lang,
      Day: A.day,
      SkinType: A.type,
      Priority: A.concern,
      Sensitivity: A.react,
      Level: A.tier,
      NewsletterOptIn: optIn
    };
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(["identify", { $email: email }]);
      window.klaviyo.push(["track", "Built a cicle", payload]);
    } catch (e) {}
    btn.disabled = true;
    form.innerHTML = '<p class="text-sm">' + esc(L.emailDone) + "</p>";
  }

  /* ---------- opening and closing ----------
     x-modal already opens itself from any [aria-controls] in the page and handles
     the overlay, the focus trap and the scroll lock. We only add a fallback for the
     case where the theme's JavaScript has not loaded. */
  var native = typeof root.show === "function" && typeof root.hide === "function";

  function open() { if (native) root.show(); else root.setAttribute("open", ""); }
  function close() { if (native) root.hide(); else root.removeAttribute("open"); }

  if (!native) {
    document.addEventListener("click", function (e) {
      var el = e.target.closest && e.target.closest('[aria-controls="' + root.id + '"]');
      if (el) { e.preventDefault(); open(); }
    });
  }

  /* ---------- wiring ---------- */
  function wire() {
    var start = body.querySelector("[data-rf-start] .button");
    if (start) start.onclick = function () { screen = 1; render(); };

    var next = body.querySelector("[data-rf-next]");
    if (next) next.onclick = function () {
      screen = (editing || screen === 4) ? "result" : screen + 1;
      editing = false;
      render();
    };

    var back = body.querySelector("[data-rf-back]");
    if (back) back.onclick = function () { screen = screen - 1; render(); };

    Array.prototype.forEach.call(body.querySelectorAll("[data-rf-goto]"), function (c) {
      c.onclick = function () {
        if (screen === "result") editing = true;
        screen = parseInt(c.getAttribute("data-rf-goto"), 10);
        render();
      };
    });

    var add = footer.querySelector("[data-rf-add]");
    if (add) add.onclick = function () { addToCart(add); };

    var copy = body.querySelector("[data-rf-copy]");
    if (copy) copy.onclick = function () {
      var L = t(), link = cicleLink(), done = function () {
        copy.textContent = L.copied;
        setTimeout(function () { copy.textContent = L.copyLabel; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(done, function () { window.prompt(L.copyLabel, link); });
      } else {
        window.prompt(L.copyLabel, link);
      }
    };

    var mailToggle = body.querySelector("[data-rf-email]");
    if (mailToggle) mailToggle.onclick = function () {
      var form = body.querySelector("[data-rf-mailform]");
      if (!form) return;
      form.hidden = false;
      mailToggle.remove();
      var field = form.querySelector("[data-rf-mailfield]");
      if (field) field.focus();
    };

    var send = body.querySelector("[data-rf-mailsend]");
    if (send) send.onclick = function () { sendCicle(send); };

    var restart = footer.querySelector("[data-rf-restart]");
    if (restart) restart.onclick = function () {
      A = { day: [], type: null, concern: null, react: null, tier: "complete" };
      picks = {};
      editing = false;
      screen = 1;
      render();
    };
  }

  /* Answers are real inputs, so the browser keeps their state. We listen once, on the
     body, and only re-render when the answer actually changes the screen. */
  body.addEventListener("change", function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains("checkbox")) return;
    var pick = input.getAttribute("data-rf-pick");
    if (pick) {
      picks[pick] = input.checked;
      Array.prototype.forEach.call(body.querySelectorAll('[data-rf-pick="' + pick + '"]'), function (el) {
        el.checked = input.checked;
      });
      refresh();
      return;
    }

    var group = input.closest("[data-rf-group]");
    if (!group) return;
    var name = group.getAttribute("data-rf-group"), value = input.value;

    if (name === "1") {
      var i = A.day.indexOf(value);
      if (input.checked) {
        if (i === -1) A.day.push(value);
        while (A.day.length > 2) {
          var dropped = A.day.shift();
          var old = group.querySelector('input[value="' + dropped + '"]');
          if (old) old.checked = false;
        }
      } else if (i > -1) {
        A.day.splice(i, 1);
      }
      var max = body.querySelector("[data-rf-max]");
      if (max) max.hidden = A.day.length < 2;
      var n1 = body.querySelector("[data-rf-next]");
      if (n1) n1.disabled = A.day.length === 0;
      picks = {};
      return;
    }

    picks = {};

    if (name === "2") A.type = value;
    else if (name === "3") A.concern = value;
    else if (name === "4") A.react = value;
    else if (name === "tier") { A.tier = value; picks = {}; render(); return; }

    var n = body.querySelector("[data-rf-next]");
    if (n) n.disabled = false;
  });

  /* ---------- a link someone saved ----------
     Opening it lands on the routine itself, not on the first question again. */
  (function () {
    var code = null;
    try { code = new URL(window.location.href).searchParams.get("cicle"); } catch (e) {}
    if (!code) return;
    if (!decodeState(code)) return;
    screen = "result";
    render();
    open();
  })();

  /* ---------- floating button and automatic opening ---------- */
  var fab = document.querySelector("[data-rf-fab]");
  if (fab) {
    if (fab.dataset.homeOnly && fab.dataset.homeOnly !== "index") fab.hidden = true;
    else requestAnimationFrame(function () { setTimeout(function () { fab.classList.add("is-visible"); }, 600); });
  }

  var delay = parseInt(root.dataset.autoDelay || "0", 10);
  if (delay > 0 && root.dataset.designMode !== "true") {
    var homeOnly = root.dataset.autoHomeOnly === "true";
    var once = root.dataset.autoOnce === "true";
    var key = "cicle:routine-finder-seen";
    var seen = false;
    try { seen = localStorage.getItem(key) === "1"; } catch (e) {}
    if ((!homeOnly || root.dataset.template === "index") && !(once && seen)) {
      setTimeout(function () {
        /* Never fight another overlay for the screen. */
        if (document.querySelector(".modal[open], .drawer[open], .popover[open], dialog[open]")) return;
        try { if (once) localStorage.setItem(key, "1"); } catch (e) {}
        open();
      }, delay * 1000);
    }
  }

  wire();
})();
